import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import userIcon from "../assets/userIcon.webp";
import "./VendorDetails.css";
import { BASE_URL, fetchVendorAnalytics } from "./../services/api";
import { fetchVendors } from "../slices/vendorSlice";

const VendorDetail = () => {
  const { vendorId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  const vendors = useSelector((state) => state.vendors.data);
  const vendor = vendors.find((vendor) => vendor._id.toString() === vendorId);

  useEffect(() => {
    if (!vendors.length) {
      // Fetch vendors if not already available
      dispatch(fetchVendors())
        .unwrap()
        .then(() => setLoading(false))
        .catch((error) => {
          console.error("Failed to fetch vendors:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [dispatch, vendors.length]);

  useEffect(() => {
    if (vendorId) {
      fetchVendorAnalytics(vendorId)
        .then((data) => setAnalytics(data))
        .catch((error) => console.error("Error fetching analytics:", error));
    }
  }, [vendorId]);

  const businessAddress = vendor?.businessAddress || {};
  const {
    addressLine1 = "",
    addressLine2 = "",
    city = "",
    state = "",
    country = "",
    postalCode = "",
  } = businessAddress;

  const addresses = addressLine1
    ? `${addressLine1} ${addressLine2 ? ", " + addressLine2 : ""}${
        city ? ", " + city : ""
      }${state ? ", " + state : ""}${country ? ", " + country : ""}${
        postalCode ? ", " + postalCode : ""
      }`
    : "address not found";

  const profileImageUrl = vendor?.profileImage
    ? `${BASE_URL}${vendor.profileImage}`
    : userIcon;

  // Display loading state
  if (loading) {
    return <div className="text-white">Loading vendor details...</div>;
  }

  // Check if vendor exists after loading
  if (!vendor) {
    return <div className="text-white">Vendor not found</div>;
  }

  return (
    <div className="vendor-detail-container mx-auto max-w-6xl p-6">
      <div className="breadcrumb text-light-gray text-sm mb-4 flex items-center">
        <span className="cursor-pointer mr-2" onClick={() => navigate(-1)}>
          &larr;
          <span>Vendor Details</span>
        </span>
      </div>
      <div className="breadcrumb-separator border-t border-gray-700 mb-6"></div>
      <div className="vendor-detail-grid grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 vendor-info space-y-6">
          <div>
            <label className="block text-light-gray text-sm">Full Name</label>
            <input
              type="text"
              value={vendor?.name ?? "Vendor Name"}
              readOnly
              className="vendor-input"
            />
          </div>
          <div>
            <label className="block text-light-gray text-sm">Email ID</label>
            <input
              type="email"
              value={vendor?.email ?? "Email"}
              readOnly
              className="vendor-input"
            />
          </div>
          <div>
            <label className="block text-light-gray text-sm">Mobile No.</label>
            <input
              type="text"
              value={vendor?.phoneNumber ?? "Phone number"}
              readOnly
              className="vendor-input"
            />
          </div>
        </div>
        <div className="vendor-image-wrapper flex justify-center items-center">
          <div
            className="vendor-image w-full h-64 rounded-full bg-cover bg-center"
            style={{ backgroundImage: `url(${profileImageUrl})` }}
          ></div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <div>
          <label className="block text-light-gray text-sm">Business Name</label>
          <input
            type="text"
            value={vendor?.businessName ?? "Business Name"}
            readOnly
            className="vendor-input"
          />
        </div>
        <div>
          <label className="block text-light-gray text-sm">
            Product Category
          </label>
          <input
            type="text"
            value={vendor?.category?.name || "N/A"}
            readOnly
            className="vendor-input"
          />
        </div>
      </div>
      <div className="vendor-info space-y-6 mt-6">
        {/* <div>
          <label className="block text-light-gray text-sm">Password</label>
          <input
            type="text"
            value={
              vendor?.password && vendor?.password.length > 6
                ? `${vendor?.password.substring(
                    0,
                    3
                  )}...${vendor?.password.substring(
                    vendor?.password.length - 3
                  )}`
                : vendor?.password ?? "N/A"
            }
            readOnly
            className="vendor-input"
          />
        </div> */}
        <div>
          <label className="block text-light-gray text-sm">Address</label>
          <textarea
            value={addresses ?? "Address not found"}
            readOnly
            className="vendor-input h-28"
          ></textarea>
        </div>
        <div>
          <label className="block text-light-gray text-sm">
            Average Selling Price
          </label>
          <input
            type="text"
            value={analytics?.averageSellingPrice.toFixed(0) ?? "N/A"}
            readOnly
            className="vendor-input"
          />
        </div>
      </div>
      <div className="vendor-metrics mt-10 flex flex-col md:flex-row gap-6">
        <div className="metric-card">
          <div className="metric-title">Total</div>
          <div className="metric-name">Earning</div>
          <div className="metric-value text-green-500">
            <span className="font-normal">€</span>
            {analytics?.totalEarnings ?? 0}
          </div>
        </div>
        <div className="metric-card">
          <div className="metric-title">Total</div>
          <div className="metric-name">Sub Categories</div>
          <div className="metric-value text-green-500">
            {analytics?.totalSubcategories ?? 0}
          </div>
        </div>
        <div className="metric-card">
          <div className="metric-title">Total</div>
          <div className="metric-name">Ratings</div>
          <div className="metric-value text-yellow-500 flex items-center">
            {analytics?.totalRatings ?? 0}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDetail;
